<template>
    <div>
        <div class="row mb-0 rooms-advanced-search">
            <div class="formdynamic__item py-0" v-for="(key, index) in form_format" :key="index" :class="key.class">
                <div class="formdynamic__item__field" >
                    <label v-html="`${key.name} ${key.required ? `<b style='color:red;'>*</b>` : ''}`" class="modal-label" :for="key.name"/>

                    <select v-if="key.type === 'select' || key.type === 'select-multiple'"
                        :disabled="key.disabled"
                        :multiple="key.type === 'select-multiple' ? true : false"
                        class="input-field custom-select"
                        :required="key.required"
                        v-model="form_data[key.model_name]"
                    >
                        <!-- <option value='' :disabled="[[key.required ? true : false], [key.type === 'select-multiple' ? true : false]]" v-html="key.name"/> -->
                        <option value='' :disabled="key.required" v-html="key.empty_option_name !== undefined && key.empty_option_name !== '' ? key.empty_option_name : 'Select an option'"/>
                        <template v-if="key.option_type == 'boolean_options'">
                            <option v-for="(value, i) in form_resources.boolean_options" :key="i" :value="value.id" v-html="key.label ? value[key.label] : value.name"/>
                        </template>
                        <template v-if="key.option_type == 'excl_options'">
                            <option v-for="(value, i) in form_resources.excl_options" :key="i" :value="value.id" v-html="key.label ? value[key.label] : value.name"/>
                        </template>
                        <template v-else>
                            <option v-for="(value, i) in array_options[key.model_name]" :key="i" :value="value.id" v-html="key.label ? value[key.label] : value.name"/>
                        </template>
                    </select>

                    <input v-else-if="key.type === 'text'" 
                        :placeholder="key['placeholder'] !== undefined ? key.placeholder : ''"
                        :disabled="key.disabled"
                        :step="key.step"
                        :type="key.type" 
                        :maxlength="key.maxlength"
                        :style="key.disabled ? 'background-color: #f1f1f1;' : ''"
                        :min="key.type === 'date' && min_date !== undefined ? min_date : key.minlength !== undefined ? key.minlength : ''"
                        :max="key.type === 'date' && max_date !== undefined ? max_date : key.maxlength"
                        :required="key.required"
                        :value="form_data[key.model_name]"
                        v-on:input="$emit('debounceInput', {value: $event.target.value, field: key.model_name})"
                    />

                    <div class="row mb-0" v-else-if="key.type === 'double-input'">
                        <div class="col-md-3 py-0">
                            <div class="formdynamic__item__field">
                                <select :disabled="key.disabled" size="" class="input-field custom-select" v-model="form_data[key.symbol_model_name]">
                                    <!-- <option value="" v-html="'Select an option'"/> -->
                                    <option v-for="(item, i) in form_resources.simbol_options" :key="i" :value="item.id" v-html="item.name"/>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-9 py-0">
                            <div class="formdynamic__item__field">
                                <input  :disabled="key.disabled" type="number" :min="0" :value="form_data[key.model_name]" class="form-control" v-on:input="$emit('debounceInput', {value: $event.target.value, field: key.model_name})"/>
                            </div>
                        </div>
                    </div>

                    <span class="d-flex" v-else-if="key.type === 'checkbox'">
                        <div class="pt-2" v-for="(checkbox, j) in key.checkboxes" :key="j">
                            <label class="modal-label" v-html="checkbox.name"/>
                            <div class="custom-control custom-checkbox">
                                <input :id="checkbox.model_name" type="checkbox" class="custom-control-input" v-model="form_data[checkbox.model_name]"/>
                                <label :for="checkbox.model_name" class="custom-control-label ml-2"/>
                            </div>
                        </div>
                    </span>

                    <div v-else-if="key.type === 'radio'">
                        <div v-for="(value, i) in key.radios" :key="i" :class="value.div_class">
                            <input 
                                :class="value.class"
                                type="radio"
                                :id="value.ref + '-advanced-search'"
                                name="radio"
                                :value="value.value"
                                v-model="form_data[key.model_name]"
                                :checked="i === key.radios.length - 1 ? true : false"
                            />
                            <label :for="value.ref + '-advanced-search'" :class="'form-check-label radiobutton__text custom-control-label'" v-html="value.name"/>
                        </div>
                    </div>

                </div>
            </div>
            <!-- <div class="formdynamic__item col-md-2 py-0">
                <div class="formdynamic__item__field">
                    <label for="Task:" class="modal-label" v-html="'Task:'"/>
                    <select size="" class="input-field custom-select" v-model="form_data.task_id" :disabled="form_data.radio && form_data.radio != 'all' ? false : true">
                        <option value="" v-html="'Select an option'" />
                        <option v-for="(item, i) in array_options.task_id" :key="i" :value="item.id" v-html="item.name"/>
                    </select>
                </div>
            </div>
            <div class="formdynamic__item col-md-2 pl-2 py-0">
                <div class="row mb-0">
                    <div class="col-md-3 py-0" v-if="form_data.radio != 'projects'">
                        <div class="formdynamic__item__field">
                            <label for="Frequency:" class="modal-label" v-html="'Frequency:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.freq_simbol" :disabled="form_data.radio && form_data.radio != 'all' ? false : true">
                                <option v-for="(item, i) in simbol_options" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-9 py-0">
                        <div class="formdynamic__item__field">
                            <label class="modal-label" :class="form_data.radio != 'projects' ? 'invisible' : ''" v-html="'Frequency:'"/>
                            <select size="" class="input-field custom-select" v-model="form_data.frequency" v-if="form_data.radio == 'projects'" :disabled="form_data.radio && form_data.radio != 'all' ? false : true">
                                <option value="" v-html="'Select an option'" />
                                <option v-for="(item, i) in array_options['frequency_id']" :key="i" :value="item.id" v-html="item.name"/>
                            </select>
                            <input v-else type="number" :min="1" class="form-control" :value="form_data['frequency']" v-on:input="$emit('debounceInput', {value: $event.target.value, field:'frequency'})" :disabled="form_data.radio && form_data.radio != 'all' ? false : true"/>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <!-- <div class="mt-3 d-flex align-items-center justify-content-center">
            <a style="width: 220px !important;" class="mx-md-0 modal__buttons__item w-auto h-auto px-3 lh-1 d-flex align-items-center justify-content-center" v-html="'Search'" @click="$emit('resetList', {})"/>
        </div> -->
    </div>
</template>

<script>

export default {

    name: 'LocalFormSearch',

    props:[
        'module_name',
        'form_format',
        'form_data',
        'form_resources',
        'array_options',
        'boolean_options',
        'radio_options',
        'simbol_options',
        'excl_options',
    ],


}

</script>